export default class Disposition {

    static readonly REWORK:number = 1;
    static readonly ACCEPT_AS_IS:number = 2;
    static readonly SCRAP:number = 3;
    static readonly RETURN:number = 4;
    static readonly REGRADE:number = 5;
    static readonly AWAITING_DISPOSITION:number = 6;
    static readonly SORT:number = 7;
    static readonly MEETS_SPEC:number = 8;

    id: number;
    desc: string;
    // bootstrap vue only sees value and text in their selectors
    value: number;
    text: string;

    constructor(){
        this.id = 0;
        this.desc = "";
        this.value = 0;
        this.text = "";
    }
}